import { Component } from '@angular/core';

@Component({
    selector: 'app-runners-report',
    templateUrl: './runners-report.component.html',
    styleUrl: './runners-report.component.css',
    standalone: false
})
export class RunnersReportComponent {

}
